// AWS Amplify v6 설정
// 모든 sedaily.io 서브도메인에서 세션 공유
const getCookieDomain = () => {
  const hostname = window.location.hostname;
  
  // 로컬 개발 환경
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return undefined;
  }
  
  // 프로덕션 도메인 - 모든 서브도메인에서 쿠키 공유
  if (hostname.includes('sedaily.io')) {
    // .sedaily.io로 설정하여 모든 서브도메인에서 쿠키 공유
    return '.sedaily.io';
  }
  
  return undefined;
};

export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID ||"",
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID ||"",
      signUpVerificationMethod:"code",
      loginWith: {
        email: true,
      },
      cookieStorage: {
        domain: getCookieDomain(),
        path: '/',
        expires: 365,
        sameSite: 'lax',
        secure: true
      }
    },
  },
  API: {
    REST: {
      api: {
        endpoint:
          process.env.REACT_APP_API_URL ||"",
        region: process.env.REACT_APP_AWS_REGION ||"us-east-1",
      },
    },
  },
};

export default awsConfig;
